// ============================================================
// CLUBHUB – Pruefung eines Mitglied-Formulars
// ============================================================
// Dieselbe Regel im Browser (sofortige Rueckmeldung am Feld) und in
// der Server Action (`app/(app)/mitglieder/actions.ts`) — deshalb hier
// und nicht in der Client-Datei des Formulars.
// ============================================================

export function pruefeMitglied(daten: FormData): Record<string, string> {
  const f: Record<string, string> = {};
  const art = daten.get("kind");
  if (art === "ORGANIZATION") {
    if (!String(daten.get("organizationName") ?? "").trim()) f.organizationName = "Bitte einen Namen angeben.";
  } else {
    if (!String(daten.get("firstName") ?? "").trim()) f.firstName = "Bitte den Vornamen angeben.";
    if (!String(daten.get("lastName") ?? "").trim()) f.lastName = "Bitte den Nachnamen angeben.";
  }
  const mail = String(daten.get("email") ?? "").trim();
  if (mail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) f.email = "Das sieht nicht nach einer Mailadresse aus.";
  for (const feld of ["birthDate", "entryDate"]) {
    const wert = String(daten.get(feld) ?? "").trim();
    if (wert && !/^\d{4}-\d{2}-\d{2}$/.test(wert)) f[feld] = "Bitte ein gültiges Datum angeben.";
  }
  return f;
}

/**
 * „Hauptstraße 12a“ → Straße und Hausnummer getrennt (strukturierte
 * SEPA-Adressen). Ohne erkennbare Nummer bleibt alles Straße.
 */
export function trenneHausnummer(zeile: string): { street: string | null; houseNumber: string | null } {
  const s = zeile.trim();
  if (!s) return { street: null, houseNumber: null };
  const m = s.match(/^(.*?\D)\s*(\d+\s*[a-zA-Z]?(?:\s*[-/]\s*\d+\s*[a-zA-Z]?)?)$/);
  if (!m) return { street: s, houseNumber: null };
  return { street: m[1]!.trim(), houseNumber: m[2]!.replace(/\s+/g, "") };
}
